'use strict';
/**
 * Entry of the pending table containing sockets being created.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var EPending =
/**
   * @param {string} temporaryId A temporary id used to retrieve the entry.
   * @param {string} peerId The identifier of the peer reachable through the
   * socket. Null if the peerId is yet to be known.
   * @param {string} protocolId The identifier of the protocol that wishes to
   * establish the connexion.
   * @param {object} socket The WebRTC socket.
   * @param {number} timeout Maximum time for a connexion to establish.
   */
function EPending(temporaryId, peerId, protocolId, socket, timeout) {
  _classCallCheck(this, EPending);

  this.tid = temporaryId; // key

  this.peer = peerId;
  this.pid = protocolId;
  this.socket = socket;
  this.successful = false;
  this.alreadyExists = false;
  this.timeout = timeout;
};

;
module.exports = EPending;